import { render, staticRenderFns } from "./translation-form-dialog.app.vue?vue&type=template&id=0f09deb8&"
import script from "./translation-form-dialog.app.vue?vue&type=script&lang=js&"
export * from "./translation-form-dialog.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports